import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as thunk from './thunk';

export const initialState = {
    dataList: [],
    logList: [],
    lastestStatusList: {},
    lastestStatusByVehicleId: {},
    lastHeartBeat: {},
    vehicle: {},
    liveAddr: {},
    error: {},
    loading: true
};

const VehicleSlice = createSlice({
    name: 'Vehicles',
    initialState,
    reducers: {},
    extraReducers: builder => {
        // <--------------------------- getAll --------------------------->
        builder.addCase(thunk.getAll.fulfilled, (state, action) => {
            state.dataList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getAll.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- create --------------------------->
        builder.addCase(thunk.create.fulfilled, (state, action) => {
            state.dataList.unshift(action.payload);
        });
        builder.addCase(thunk.create.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- update --------------------------->
        builder.addCase(thunk.update.fulfilled, (state, action) => {
            const data = action.payload;
            const id = data.id;
            if (_.isEmpty(id)) {
                return;
            }

            const dataList = (state.dataList || []).filter(x => x.id !== id);
            dataList.unshift(data);
            state.dataList = dataList;
        });
        builder.addCase(thunk.update.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- remove --------------------------->
        builder.addCase(thunk.remove.fulfilled, (state, action) => {
            state.dataList = state.dataList.filter(x => x.id !== action.payload);
        });
        builder.addCase(thunk.remove.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getById --------------------------->
        builder.addCase(thunk.getById.fulfilled, (state, action) => {
            state.vehicle = _.cloneDeep(action.payload);
        });
        builder.addCase(thunk.getById.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLogs --------------------------->
        builder.addCase(thunk.getLogs.fulfilled, (state, action) => {
            state.logList = action.payload;
        });
        builder.addCase(thunk.getLogs.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLogsPartial --------------------------->
        builder.addCase(thunk.getLogsPartial.fulfilled, (state, action) => {
            state.logList = action.payload;
        });
        builder.addCase(thunk.getLogsPartial.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLastHeartBeat --------------------------->
        builder.addCase(thunk.getLastHeartBeat.fulfilled, (state, action) => {
            console.log('action.payload', action.payload);
            state.lastHeartBeat = action.payload;
        });
        builder.addCase(thunk.getLastHeartBeat.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getYs7LiveAddr --------------------------->
        builder.addCase(thunk.getYs7LiveAddr.fulfilled, (state, action) => {
            state.liveAddr = action.payload;
        });
        builder.addCase(thunk.getYs7LiveAddr.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLastestStatus --------------------------->
        builder.addCase(thunk.getLastestStatus.fulfilled, (state, action) => {
            state.lastestStatusList = action.payload;
        });
        builder.addCase(thunk.getLastestStatus.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLastestStatusByVehicleId --------------------------->
        builder.addCase(thunk.getLastestStatusByVehicleId.fulfilled, (state, action) => {
            state.lastestStatusByVehicleId = action.payload;
        });
        builder.addCase(thunk.getLastestStatusByVehicleId.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
    }
});

export default VehicleSlice.reducer;
